export const regexPatterns = {
  applicationHostRegex: /^[^:]+:\/\/[^/]+/,
  isInSectionViewRegex: /\/teams\/\d+\/documents\/\d+\/?#?\/sections\/\d+\//,
};

